<!--
 * @Author: liliujun
 * @Date: 2025-04-17
 * @LastEditors: liliujun
 * @LastEditTime: 2025-04-19
 * @FilePath: /mall/yunNanMall/src/views/free-purchase/index.vue
 * @Description:
-->
<template>
  <div class="free-purchase">
    <div class="login-wrapper">
      <div class="user" v-if="userInfo">
        <div class="phone">{{ userInfo.phone }}</div>
        <div class="layout" @click="layout">退出</div>
      </div>
      <div class="login" v-else @click="$router.push({ name: 'login' })">
        点击登录
      </div>
    </div>
    <div class="notice">
      大品牌超多款手机，任你挑选 <br />
      手机价格与市场一致，绝无虚价<br />
      办理移动对应套餐，0元购机
    </div>
    <div class="btn" @click="onClick">看看我能拿什么手机</div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
export default {
  computed: {
    ...mapState('store', ['userInfo', 'Authorization'])
  },
  methods: {
    ...mapActions('store', ['layout']),
    onClick () {
      if (!this.Authorization) {
        this.$toast('您还没有登录')
        this.$router.push({ name: 'login' })
        return false
      }
      this.$router.push({ path: '/freePurchaseOrder' })
    }
  }
}
</script>

<style lang="less" scoped>
.free-purchase {
  padding: 9.34rem 0.3rem 0;
  min-height: calc(100vh - 9.34rem);
  background: url('./image/bg.png') top no-repeat #ffcf4d;
  background-size: 100% 13.07rem;
  .login-wrapper {
    position: absolute;
    top: 0.8rem;
    right: 0rem;
    font-size: 0.26rem;
    color: #fff;

    .user {
      display: flex;
      align-items: center;
      padding: 0.04rem 0.2rem;
      background-color: #fc681e;
      border-radius: 30px 0 0 30px;
      .layout {
        margin-left: 0.3rem;
      }
    }
    .login {
      padding: 0.04rem 0.2rem;
      display: inline-flex;
      background-color: #fc681e;
      border-radius: 30px 0 0 30px;
    }
  }
  .notice {
    padding: 0.28rem 1.2rem 0.3rem;
    font-size: 0.32rem;
    color: #bb3c23;
    text-align: center;
    font-weight: bold;
    background: linear-gradient(
      180deg,
      #ffffff 0%,
      rgba(255, 255, 255, 0.55) 100%
    );
    border-radius: 0.24rem;
  }
  .btn {
    margin: 0.3rem auto 0;
    width: 6.9rem;
    height: 0.78rem;
    .flex-center;
    font-size: 0.32rem;
    color: #fff;
    background: linear-gradient(180deg, #ff5c07 0%, #ff2f03 100%);
    border-radius: 30px;
  }
}
</style>
